/**
 * The base URL for all office search related API endpoints in servlet code.
 */
export const BASE_URL = '/acp-ofiklo030-officesearch-vs';

export const OFFICE_SEARCH_BASE_URL = 'api/office-search';

/**
 * The endpoint for fetching autosuggest results based on user input.
 */
export const AUTOSUGGEST_URL = '/auto-suggest';

/**
 * The endpoint for performing office search queries.
 */
export const SEARCH_URL = '/search';

/**
 * The endpoint for retrieving detailed information about a specific office.
 */
export const OFFICE_DETAILS_URL = '/officeDetails';

export const GET_CSRF_TOKEN_URL = '/csrftokens';

export enum Language {
  fi = 'fi',
  sv = 'sv',
  en = 'en'
}
